import { useRecoilValue } from 'recoil'
import eventsAtom from '../../events.atom'
import { IEvent } from '../../events.types'
import { useMemo } from 'react'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  name?: string
  value: IEvent['id']
  onChange: (val: IEvent['id'], name: string) => void
}

const EventsDropdown = (props: IProps) => {
  const events = useRecoilValue(eventsAtom).items

  const options = useMemo(() => {
    return events.map((e) => ({ title: e.name, value: e.id }))
  }, [events])

  const onChange = (option: { title: string; value: number }, name: string) => {
    props.onChange(option?.value ?? null, name)
  }

  const selected = useMemo(() => {
    return options.find((o) => o.value === props.value) || null
  }, [props.value, options])

  return (
    <Dropdown
      options={options}
      selectedOption={selected}
      title='Событие'
      onSelect={onChange}
      name={props.name}
      getOptionKey={(o) => o?.value}
      getOptionLabel={(o) => o?.title}
    />
  )
}

export default EventsDropdown
